import React, { useState, useRef, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Form, Divider } from 'antd'
import _ from 'lodash'
import FormInput from '../../design/Form/Input'
import FormCheckbox from '../../design/Form/Checkbox'
import ButtonPurple from '../../design/Form/ButtonPurple'
import ButtonWhiteLink from '../../design/Form/ButtonWhiteLink'
import style from '../../../layouts/Auth/style.module.scss'
// import styles from './style.module.scss'

const SSOForm = ({ headerTitle, footer }) => {
  const [form] = Form.useForm()
  const [email, setEmail] = useState('')
  const [name, setName] = useState('')
  const user = useSelector(state => state.user)
  const nameRef = useRef()

  useEffect(() => {
    nameRef.current.focus()
  }, [])

  const onFinish = () => {
    form.validateFields().then(values => {
      values.name = name
      values.email = email
    })
  }

  const handleEmailInput = e => {
    setEmail({ email: e.target.value })
  }

  const handleNameInput = e => {
    setName({ name: e.target.value })
  }

  const v2AuthFormContainerClasses = `${style.v2AuthFormContainer} col-xl-6 col-md-6 col-xs-12 col-sm-12`

  return (
    <div className={v2AuthFormContainerClasses}>
      {headerTitle}
      <div className={style.formWrapper} style={{ width: '511px !important' }}>
        <Form
          form={form}
          hideRequiredMark
          onFinish={onFinish}
          className="mb-4"
          initialValues={{ email: user.prefilledSignupEmail, name }}
        >
          <FormInput
            onChange={handleNameInput}
            Form={Form}
            label="Name"
            name="name"
            value={name}
            placeholder="Full Name"
            rules={[{ required: true, message: 'Please enter your name' }]}
            ref={nameRef}
          />
          <FormInput
            onChange={handleEmailInput}
            Form={Form}
            label="Email"
            name="email"
            value={email}
            placeholder="Email Address"
            rules={[
              { required: true, message: 'Please enter your email' },
              {
                type: 'email',
                message: 'Please enter a valid email',
              },
            ]}
            disabled={
              _.trim(user.prefilledSignupEmail).length > 0 && user.prefilledSignupEmailDisabled
            }
          />

          <div className={style.checkboxInputWrapper}>
            <FormCheckbox
              Form={Form}
              valuePropName="checked"
              rules={[
                {
                  validator: (r, value) =>
                    value
                      ? Promise.resolve()
                      : Promise.reject(
                          new Error(
                            'Please read the terms and privacy policy before agreeing to proceed',
                          ),
                        ),
                },
              ]}
              name="agreeToTerms"
              content={
                <React.Fragment>
                  {' '}
                  I agree to the{' '}
                  <a
                    href="https://www.cometchat.com/legal-terms-of-service"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Terms
                  </a>{' '}
                  and{' '}
                  <a
                    href="https://www.cometchat.com/legal-privacy-policy"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Privacy Policy
                  </a>
                </React.Fragment>
              }
            />
          </div>
          <ButtonPurple
            buttonText="Complete your Registration"
            buttonType="submit"
            loading={user.loading}
          />
        </Form>
        <Divider className={style.dividerCustom} />
        <div id={style.newAccountText}>Already have an account?</div>
        <ButtonWhiteLink buttonText="Login" to="/login" />
      </div>
      {footer}
    </div>
  )
}

export default SSOForm
